import BroadcastsList from "../../../components/esim/broadcasts";
import HeaderPage from "../../../components/lines-managements/header/HeaderPage";

const BroadcastsPage: React.FC = () => {
  return (
    <>
      <HeaderPage
        querySelector="searchKeyword"
        link={{
          to: "add",
          children: "Krijo njoftim të ri",
          state: ["Esim", "Njoftimet", "Krijo njoftim të ri"]
        }}
      />
      <BroadcastsList />
    </>
  );
};

export default BroadcastsPage;
